export default function DistrictController($scope, $stateParams, DataService, MapService, MapDrawService, TitleService, NotificationService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.districtId = $stateParams.districtId;
		vm.loading = true;
		DataService.getDistrict(vm.districtId).then((district) => {
			TitleService.setTitleOrg(district);

			vm.district = district;
			vm.assigned = DataService.getAssignedOrgs(vm.district);
			vm.map = DataService.instantMap();
			vm.recenter();

			DataService.setMapOpts({selectedOrg: vm.district, automaticOrgs: vm.assigned});

			vm.loading = false;
		}, NotificationService.exception(vm));
	};

	vm.recenter = () => {
		MapService.centerMap(vm.district, vm.map);
	};

}
